<footer class="bg-primary footer">
    <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between center" class="footercontainer copyright secondary-color theme-container">
        <p ngClass.xs="mt-1">Copyright © {{ annio }} All Rights Reserved</p>
        <p><a mat-button href="https://www.clavisco.com/" target="_blank">Clavis Consultores S.A.</a></p>
    </div>
</footer>